"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentError = exports.PromoCodeError = exports.GeneralError = exports.AuthenticationError = exports.SecurityError = void 0;
// These errors usually mean that someone is trying to compromise security,
// or something went wrong with our authentication system
var SecurityError;
(function (SecurityError) {
    SecurityError["MISSING_AUTH"] = "No auth provided";
    SecurityError["NO_TOKEN"] = "Login token not provided";
    SecurityError["INVALID_TOKEN"] = "Invalid token";
    SecurityError["EXPIRED_TOKEN"] = "Expired token";
    SecurityError["INVALID_USER_ID"] = "User ID is invalid";
    SecurityError["INVALID_COURSE_ID"] = "Course ID is invalid";
})(SecurityError || (exports.SecurityError = SecurityError = {}));
// General errors related to failing to login (typically user error)
var AuthenticationError;
(function (AuthenticationError) {
    AuthenticationError["INVALID_EMAIL"] = "INVALID_EMAIL";
    AuthenticationError["INVALID_PASSWORD"] = "INVALID_PASSWORD";
    AuthenticationError["INVALID_GOOGLE_TOKEN"] = "INVALID_GOOGLE_TOKEN";
    AuthenticationError["INCORRECT_PASSWORD"] = "INCORRECT_PASSWORD";
    AuthenticationError["EMAIL_NOT_FOUND"] = "EMAIL_NOT_FOUND";
    AuthenticationError["USER_WITH_EMAIL_EXISTS"] = "USER_WITH_EMAIL_EXISTS";
    AuthenticationError["NO_PASSWORD_GOOGLE_LOGIN"] = "NO_PASSWORD_GOOGLE_LOGIN";
    AuthenticationError["INVALID_TOKEN_DURING_RESET_PASSWORD"] = "INVALID_TOKEN_DURING_RESET_PASSWORD";
})(AuthenticationError || (exports.AuthenticationError = AuthenticationError = {}));
var GeneralError;
(function (GeneralError) {
    GeneralError["NOT_YET_IMPLEMENTED"] = "This feature is not yet implemented";
    GeneralError["UNEXPECTED_ERROR"] = "An unexpected error occurred";
})(GeneralError || (exports.GeneralError = GeneralError = {}));
var PromoCodeError;
(function (PromoCodeError) {
    PromoCodeError["INVALID_PROMO_CODE"] = "INVALID_PROMO_CODE";
    PromoCodeError["EXAM_MISMATCH"] = "EXAM_MISMATCH";
    PromoCodeError["DOMAIN_MISMATCH"] = "DOMAIN_MISMATCH";
    PromoCodeError["EMAIL_MISMATCH"] = "EMAIL_MISMATCH";
    PromoCodeError["ALREADY_PURCHASED_FROM_JEP"] = "ALREADY_PURCHASED_FROM_JEP";
})(PromoCodeError || (exports.PromoCodeError = PromoCodeError = {}));
var PaymentError;
(function (PaymentError) {
    PaymentError["COURSE_ALREADY_OWNED"] = "COURSE_ALREADY_OWNED";
})(PaymentError || (exports.PaymentError = PaymentError = {}));
//# sourceMappingURL=errors.js.map